import type { SyncMeldung } from '../offline';

/**
 * Abgleichmeldung in der Kopfzeile (bisher direkt in `App.tsx`). Nur ein vollständig
 * erfolgreicher Lauf erscheint grün; eine Abweisung nutzt die vorhandene Fehlerdarstellung
 * (`karte fehler`, `role="alert"`) wie die übrigen Sperrmeldungen der Kasse.
 */
export function SyncMeldungKarte({
  meldung,
  onSchliessen,
}: {
  meldung: SyncMeldung;
  onSchliessen: () => void;
}) {
  return (
    <div
      className={`karte ${meldung.art}`}
      role={meldung.art === 'ok' ? 'status' : 'alert'}
      style={{ margin: '0.5rem 1rem 0', padding: '0.5rem 1rem' }}
    >
      {meldung.text}{' '}
      <button className="taste zweit" onClick={onSchliessen}>
        OK
      </button>
    </div>
  );
}
